import ShellApi from 'a365-shell-api';
import { placeholderForTitle } from 'app/shared/utils/dialog.util';


export const pipelineRunAnchorIds = {
    MonitorIcon: 'pipelinerun-pipelinerunicon',
    DateTime: 'pipelinerun-datetime',
    Timezone: 'pipelinerun-timezone',
    Table: 'pipelinerun-table',
    Filter: 'pipelinerun-filter'
};

export const pipelineRunTourSteps: ShellApi.tour.IStepOption[] = [
    {
        anchorId: pipelineRunAnchorIds.MonitorIcon,
        title: placeholderForTitle, // Todo: wait for the language
        content: stringResources.Tour_Pipelinerun_FirstTime
    }, {
        anchorId: pipelineRunAnchorIds.DateTime,
        title: placeholderForTitle, // Todo: wait for the language
        content: stringResources.Tour_Pipelinerun_Datetime,
        offsetLeft: -50
    }, {
        anchorId: pipelineRunAnchorIds.Timezone,
        title: placeholderForTitle, // Todo: wait for the language
        content: stringResources.Tour_Pipelinerun_Timezone,
        offsetLeft: -50
    }, {
        anchorId: pipelineRunAnchorIds.Table,
        title: placeholderForTitle, // Todo: wait for the language
        content: stringResources.Tour_Pipelinerun_Columns,
        offsetTop: 16,
        offsetLeft: 420
    },  {
        anchorId: pipelineRunAnchorIds.Table,
        title: placeholderForTitle, // Todo: wait for the language
        content: stringResources.Tour_Pipelinerun_ViewRun,
        offsetTop: 16,
        offsetLeft: 250
    },  {
        anchorId: pipelineRunAnchorIds.Filter,
        title: placeholderForTitle, // Todo: wait for the language
        content: stringResources.Tour_Pipelinerun_Filters,
        arrowPosition: 'right',
        offsetLeft: 25
    }
];
